// src/components/AllCars.js
import React, { useState } from "react";
import styled from "styled-components";
import axios from "axios";
import NewCar from "./NewCar";

const Container = styled.div`
  max-width: 900px;
  margin: 2rem auto;
`;

const CardList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

const Card = styled.div`
  border: 1px solid #ccc;
  padding: 1rem;
  border-radius: 8px;
  width: 250px;
  position: relative;
  background-color: #fff;
`;

const Preview = styled.img`
  width: 100%;
  border-radius: 4px;
`;

const Checkbox = styled.input`
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
`;

const Button = styled.button`
  margin-top: 1.5rem;
  padding: 0.8rem 1.5rem;
  background-color: #e63946;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background-color: #c12c3a;
  }
`;

const AllCars = ({ userCars, setUserCars }) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const token = localStorage.getItem("token");

  console.log("🟢 userCars inside AllCars:", userCars);

  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleBulkDelete = async () => {
    try {
      await Promise.all(
        selectedIds.map((id) =>
          axios.delete(`/api/AffordableCars/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
        )
      );
      setUserCars((prev) =>
        prev.filter((p) => !selectedIds.includes(p._id))
      );
      setSelectedIds([]);
      alert("Selected products deleted.");
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Error deleting products.");
    }
  };

  return (
    <Container>
      <h2>My Products</h2>

      <CardList>
        {Array.isArray(userCars) && userCars.length > 0 ? (
          userCars.map((car) => (
            <Card key={car._id}>
              <Checkbox
                type="checkbox"
                checked={selectedIds.includes(car._id)}
                onChange={() => handleCheckboxChange(car._id)}
              />
              <Preview
                src={`/uploads/${car.img}`}

                alt={car.model}
              />
              <h4>
                {car.marque} {car.model}
              </h4>
              <p>
                <strong>Year:</strong> {car.year}
              </p>
              <p>
                <strong>Odometer:</strong> {car.odometer} km
              </p>
              <p>
                <strong>Location:</strong> {car.location}
              </p>
              <p>
                <strong>Mobile:</strong> {car.mobile}
              </p>
              <p>
                <strong>Price:</strong> ${car.price}
              </p>
              <p
                style={{
                  fontSize: "0.9rem",
                  color: "#555",
                  whiteSpace: "pre-wrap",
                }}
              >
                {car.description}
              </p>
            </Card>
          ))
        ) : (
          <p style={{ marginTop: "1rem", color: "#777" }}>
            🚫 No products found. Try adding one above!
          </p>
        )}
      </CardList>

      {selectedIds.length > 0 && (
        <Button onClick={handleBulkDelete}>
          Delete Selected ({selectedIds.length})
        </Button>
      )}
    </Container>
  );
};

export default AllCars;
